import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { DOCGEN_MONTHLY_STATEMENT_JOB_BASE_PATH } from '../../../../../../../../../../features/generate/monthly-statement/job/docgen-monthly-statement-job-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/operations/_operations/generate/monthly-statement/job/_job')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: `monthly-statement-job-list`,
        label: 'Monthly Statements',
        to: DOCGEN_MONTHLY_STATEMENT_JOB_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
